export default __webpack_public_path__ + "static/media/calc.a8b8537f.svg";